<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper" [ngClass]="{ 'show-sidebar': showMobileMenu }" [dir]="options.dir"
  [attr.data-theme]="options.theme" [attr.data-layout]="options.layout" [attr.data-sidebartype]="options.sidebartype"
  [attr.data-sidebar-position]="options.sidebarpos" [attr.data-header-position]="options.headerpos"
  [attr.data-boxed-layout]="options.boxed" data-sidebartype="full">
  <!-- ============================================================== -->
  <!-- Topbar header - style you can find in topbar.scss -->
  <!-- ============================================================== -->
  <header class="topbar" [attr.data-navbarbg]="options.navbarbg" id="menu-movil">
    <nav class="d-flex top-navbar navbar-expand-lg p-3 gap-3"
      [ngClass]="options.navbarbg == 'skin6' ? 'navbar-light' : 'navbar-light'">
      <div class="navbar-header" [ngClass]="expandLogo ? 'expand-logo' : ''" [attr.data-logobg]="options.logobg">
        <!-- ============================================================== -->
        <!-- Logo -->
        <!-- ============================================================== -->
        <a class="navbar-brand" [routerLink]="['/dashboard/inicio']">
          <!-- Logo icon -->
          <b class="logo-icon">
            <img src="https://apetac.superhostingdelta.com/public/template/images/logo-apetac.png" class="light-logo"
              style="width: 60px;" />
          </b>
        </a>
        <!-- ============================================================== -->
        <!-- End Logo -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Toggle which is visible on mobile only -->
        <!-- ============================================================== -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="fa fa-bars"></span>
        </button>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse collapse" id="navbarSupportedContent" [attr.data-navbarbg]="options.navbarbg"
        [ngbCollapse]="!isCollapsed">
        <div class="w-100">
          <ul class="navbar-nav me-auto d-flex gap-5 float-start">
            <li class="nav-item d-none d-lg-block">
              <button class="btn btn-primary2" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="fa fa-bars"></i>
              </button>
            </li>


            <!-- ============================================================== -->
            <!-- create new -->
            <!-- ============================================================== -->

            <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" [routerLink]="['/dashboard/inicio']"
                id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="">Inicio</span>
              </a>
            </li>



            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">CETAC
                  <i class="fa fa-angle-down"></i>
                </span>
                <span class="d-block d-md-none">
                  CETAC <i class="fa fa-angle-down"></i>
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <a class="dropdown-item" [routerLink]="['/cetac/lista']">Gestión de CETAC</a>
                <a class="dropdown-item" [routerLink]="['/cetac/editar']">Nuevo CETAC</a>

              </div>
            </li>
            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">Asociados vigentes
                  <i class="fa fa-angle-down"></i>
                </span>
                <span class="d-block d-md-none">
                  Asociados vigentes <i class="fa fa-angle-down"></i>
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <a class="dropdown-item" [routerLink]="['/asociados-vigentes/lista']">Gestión de asociados</a>
                <a class="dropdown-item" [routerLink]="['/asociados-vigentes/editar']">Nuevo asociado</a>

              </div>
            </li>

            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">Cursos
                  <i class="fa fa-angle-down"></i>
                </span>
                <span class="d-block d-md-none">
                  Cursos<i class="fa fa-angle-down"></i>
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <a class="dropdown-item" [routerLink]="['/cursos/lista']">Gestión de cursos</a>
                <a class="dropdown-item" [routerLink]="['/cursos/editar']">Nuevo curso</a>

              </div>
            </li>
            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">Técnicos certificados
                  <i class="fa fa-angle-down"></i>
                </span>
                <span class="d-block d-md-none">
                  Tecnicos certificados<i class="fa fa-angle-down"></i>
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <a class="dropdown-item" [routerLink]="['/tecnicos/lista']">Gestión de técnicos</a>
                <a class="dropdown-item" [routerLink]="['/tecnicos/editar']">Nuevo técnico</a>

              </div>
            </li>


            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">Empresa asociada
                  <i class="fa fa-angle-down"></i>
                </span>
                <span class="d-block d-md-none">
                 Empresa asociada<i class="fa fa-angle-down"></i>
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <a class="dropdown-item" [routerLink]="['/empresas/lista']">Gestión de empresas</a>
                <a class="dropdown-item" [routerLink]="['/empresas/editar']">Nueva empresa</a>

              </div>
            </li>



            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">Portal <i class="fa fa-angle-down"></i></span>
                <span class="d-block d-md-none">Portal <i class="fa fa-angle-down"></i></span>
              </a>

              <div class="dropdown-menu p-3" aria-labelledby="navbarDropdown" ngbDropdownMenu style="min-width: 500px;">
                <div class="row g-3">
                  <!-- Columna izquierda -->
                  <div class="col-6 border-end pe-3">
                    <h6 class="dropdown-header text-uppercase text-muted">Noticias</h6>
                    <a class="dropdown-item " [routerLink]="['/noticias/lista']">Gestión de noticias</a>
                    <a class="dropdown-item " [routerLink]="['/noticias/editar']">Nueva noticia</a>
                    <h6 class="dropdown-header text-uppercase text-muted">Categórias de noticia</h6>
                    <a class="dropdown-item " [routerLink]="['/noticia-categorias/lista']">Gestión de noticia
                      categoria</a>
                    <a class="dropdown-item " [routerLink]="['/noticia-categorias/editar']">Nueva noticia categoria</a>
                    <h6 class="dropdown-header text-uppercase text-muted">Marcas Asociadas</h6>
                    <a class="dropdown-item " [routerLink]="['/marca-asociada/lista']">Gestión de marcas asociadas</a>
                    <a class="dropdown-item " [routerLink]="['/marca-asociada/editar']">Nueva marca asociada</a>
                    <!-- <a class="dropdown-item border-bottom" [routerLink]="['/sliders/lista']">Gestión de sliders</a> -->
                    <!-- <a class="dropdown-item border-bottom" [routerLink]="['/contenido-web/lista']">Contenidos web</a> -->
                  </div>

                  <!-- Columna derecha -->
                  <div class="col-6 ps-3">
                    <h6 class="dropdown-header text-uppercase text-muted">Sliders</h6>
                    <a class="dropdown-item " [routerLink]="['/sliders/lista']">Gestión de sliders</a>
                    <a class="dropdown-item " [routerLink]="['/sliders/editar']">Nuevo slider</a>
                    <h6 class="dropdown-header text-uppercase text-muted">Contenido web</h6>
                    <a class="dropdown-item " [routerLink]="['/contenido-web/lista']">Gestión de contenido
                      web</a>
                    <a class="dropdown-item " [routerLink]="['/contenido-web/editar']">Nuevo contenido
                      web</a>
                  </div>
                </div>
              </div>
            </li>


            <li class="nav-item dropdown" ngbDropdown routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-block">Configuración
                  <i class="fa fa-angle-down"></i>
                </span>
                <span class="d-block d-md-none">
                  Configuración
                  <i class="fa fa-angle-down"></i>
                </span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <a class="dropdown-item" [routerLink]="['/usuarios/lista']">Gestión de usuarios</a>
                <a class="dropdown-item" [routerLink]="['/configuraciones/lista']">Configuración base</a>
                <a class="dropdown-item" [routerLink]="['/mensajes/lista']">Gestión de mensajes</a>
              </div>
            </li>

          </ul>
          <!-- ============================================================== -->
          <!-- Right side toggle and nav items -->
          <!-- ============================================================== -->
          <ul class="navbar-nav float-end" id="cerrar">

            <li class="nav-item dropdown" ngbDropdown>
              <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
                role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src="/user4.jpg" alt />
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
                <div class="bg-fondo">
                  <img src="/user4.jpg" alt />
                  <h5>RNPM<h6>{{usuario.nombres}}</h6>
                  </h5>
                </div>
                <a class="dropdown-item" (click)="logout()"><i class="fa fa-power-off"></i> Cerrar Sesión</a>
                <!--<a class="dropdown-item" [routerLink]="['/estados/lista']">Gestión de estados</a>
                <a class="dropdown-item" [routerLink]="['/parametros/lista']">Gestión de parametros</a>-->
              </div>
            </li>
          </ul>

        </div>

      </div>

    </nav>
  </header>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Page wrapper  -->
  <!-- ============================================================== -->
  <div class="page-wrapper">
    <app-breadcrumb></app-breadcrumb>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <router-outlet></router-outlet>
      <!-- ============================================================== -->
      <!-- End Start Page Content -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- footer -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- End footer -->
    <!-- ============================================================== -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->
  <div class="chat-windows"></div>
</div>
<!-- <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="bg-fondo">
      <img src="/user4.jpg" alt />
      <div class="dropdown">
        <a class="btn btn-secondary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          RNPM <i class="fa fa-angle-down"></i>
        </a>

        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="logout()"><i class="fa fa-power-off"></i> Cerrar sesión</a></li>
        </ul>

        <h4>{{usuario.nombres}}</h4>

      </div>


    </div>

  </div>

</div> -->
<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body">

    <!-- Usuario -->
    <div class="bg-fondo">
      <img src="/user4.jpg" alt="Usuario">
      <div class="dropdown">
        <a class="btn btn-secondary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          RNPM <i class="fa fa-angle-down"></i>
        </a>

        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="logout()"><i class="fa fa-power-off"></i> Cerrar sesión</a></li>
        </ul>

        <h4>{{usuario.nombres}}</h4>

      </div>
    </div>

    <!-- Menú -->
    <ul class="nav flex-column">

      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/dashboard/inicio']" routerLinkActive="active">
          <span>Inicio</span>
        </a>
      </li>

      <!-- Cetac -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Cetac</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['/cetac/lista']">Gestión de cetac</a>
          <a class="dropdown-item" [routerLink]="['/cetac/editar']">Nuevo cetac</a>
        </div>
      </li>

      <!-- Asociados -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Asociados vigentes</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['/asociados-vigentes/lista']">Gestión de asociados</a>
          <a class="dropdown-item" [routerLink]="['/asociados-vigentes/editar']">Nuevo asociado</a>
        </div>
      </li>

      <!-- Cursos -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Cursos</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['/cursos/lista']">Gestión de cursos</a>
          <a class="dropdown-item" [routerLink]="['/cursos/editar']">Nuevo curso</a>
        </div>
      </li>

      <!-- Técnicos -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Técnicos certificados</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['/tecnicos/lista']">Gestión de técnicos</a>
          <a class="dropdown-item" [routerLink]="['/tecnicos/editar']">Nuevo técnico</a>
        </div>
      </li>

      <!-- Empresas -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Empresa asociada</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['/empresas/lista']">Gestión de empresas</a>
          <a class="dropdown-item" [routerLink]="['/empresas/editar']">Nueva empresa</a>
        </div>
      </li>

      <!-- Portal -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Portal</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <h6 class="dropdown-header">Noticias</h6>
          <a class="dropdown-item" [routerLink]="['/noticias/lista']">Gestión de noticias</a>
          <a class="dropdown-item" [routerLink]="['/noticias/editar']">Nueva noticia</a>

          <h6 class="dropdown-header">Categorías</h6>
          <a class="dropdown-item" [routerLink]="['/noticia-categorias/lista']">Gestión de categorías</a>
          <a class="dropdown-item" [routerLink]="['/noticia-categorias/editar']">Nueva categoría</a>

          <h6 class="dropdown-header">Marcas Asociadas</h6>
          <a class="dropdown-item" [routerLink]="['/marca-asociada/lista']">Gestión de marcas</a>
          <a class="dropdown-item" [routerLink]="['/marca-asociada/editar']">Nueva marca</a>

          <h6 class="dropdown-header">Sliders</h6>
          <a class="dropdown-item" [routerLink]="['/sliders/lista']">Gestión de sliders</a>
          <a class="dropdown-item" [routerLink]="['/sliders/editar']">Nuevo slider</a>

          <h6 class="dropdown-header">Contenido Web</h6>
          <a class="dropdown-item" [routerLink]="['/contenido-web/lista']">Gestión de contenido</a>
          <a class="dropdown-item" [routerLink]="['/contenido-web/editar']">Nuevo contenido</a>
        </div>
      </li>

      <!-- Configuración -->
      <li ngbDropdown class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle>Configuración</a>
        <div ngbDropdownMenu class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['/usuarios/lista']">Gestión de usuarios</a>
          <a class="dropdown-item" [routerLink]="['/configuraciones/lista']">Configuración base</a>
          <a class="dropdown-item" [routerLink]="['/mensajes/lista']">Gestión de mensajes</a>
        </div>
      </li>

    </ul>
  </div>
</div>
